import { Tooltip } from 'antd';

import type { WithTooltipPropsType as Props } from '@app/components/WithTooltip/types';

import type { FC } from 'react';

export const WithTooltip: FC<Props> = ({ show, children, ...props }) => {
  if (show) {
    return (
      <Tooltip {...props}>
        <div style={{ width: '100%' }}>{children}</div>
      </Tooltip>
    );
  }

  return <>{children}</>;
};
